var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 40.6667V27.3333H35.3333C36.3942 27.3333 37.4116 27.7548 38.1618 28.5049C38.9119 29.2551 39.3333 30.2725 39.3333 31.3333C39.3333 32.3942 38.9119 33.4116 38.1618 34.1618C37.4116 34.9119 36.3942 35.3333 35.3333 35.3333H30M24.6667 22H43.3333C44.8061 22 46 23.1939 46 24.6667V43.3333C46 44.8061 44.8061 46 43.3333 46H24.6667C23.1939 46 22 44.8061 22 43.3333V24.6667C22 23.1939 23.1939 22 24.6667 22Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingIcon);
export default __webpack_public_path__ + "static/media/parking-icon.4f96949e91b983855a04d886466142b8.svg";
export { ForwardRef as ReactComponent };